module.exports = __webpack_public_path__ + "static/media/event-services-img43.bd8dd5f7.jpg";